import React, { useRef } from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import useOutsideClick from '../Common/hooks/useOutsideClick'; 

const LoginPage = () => {
    const navigate = useNavigate();
    const authWrapperRef = useRef(null); // Authenticatorコンポーネントを囲むdivへの参照

    // 外部クリックを検出して実行するアクション
    const handleOutsideClick = () => {
        navigate('/'); // 例: ルートページにナビゲートする
    };

    // useOutsideClickフックを使用して外部クリックを検出
    useOutsideClick(authWrapperRef, handleOutsideClick);

    return (
        <div ref={authWrapperRef} className='auth-container'>
            <Authenticator className='authen custom-authenticator-container' hideSignUp={true} signUp={false} ForgotPassword={false}>
                {({ signOut, user }) => {
                    // 認証が完了したら（user が存在する場合）、SalesRootsV2 に遷移する
                    if (user) {
                        navigate('/SalesRoots');
                    }
                    return null; // ここでは特に何もレンダリングしない
                }}
            </Authenticator>
        </div>
    );
}

export default LoginPage;
